// Stage configuration constants for candidate onboarding stages

export interface StageReopenOption {
  id: string;
  label: string;
  type: 'checkbox' | 'radio';
  mandatory?: boolean;
  name?: string; // For radio button grouping
}

export interface StageConfig {
  stageNumber: number;
  title: string;
  description: string;
  reopenOptions: StageReopenOption[];
  notificationOption?: StageReopenOption; // Separate notification option
}

export const STAGE_CONFIGS: Record<number, StageConfig> = {
  1: {
    stageNumber: 1,
    title: 'Personal Details & Interview',
    description: 'This will allow Personal Details, Qualifications and Job Preferences to be edited, and Stage 1 will need to be resubmitted.',
    reopenOptions: [
      {
        id: 'reopen_id_verification',
        label: 'Reopen ID Verification step as well',
        type: 'checkbox',
      },
      {
        id: 'reopen_online_interview',
        label: 'Reopen Online Interview step as well',
        type: 'checkbox',
      },
    ],
    notificationOption: {
      id: 'notify_employee',
      label: 'Notify and request employee to edit themselves and resubmit',
      type: 'checkbox'
    },
  },
  2: {
    stageNumber: 2,
    title: 'Compliance Checks',
    description: 'This will allow Police Check, Working With Children, Right To Work and Reference Check to be edited, and Stage 2 will need to be resubmitted.',
    reopenOptions: [
      {
        id: 'admin_complete',
        label: 'Admin to complete on behalf of employee',
        type: 'radio',
        name: 'completion_method',
      },
      {
        id: 'notify_employee_referoo',
        label: 'Notify and request employee to edit themselves and resubmit via Referoo',
        type: 'radio',
        name: 'completion_method',
      },
    ],
  },
  3: {
    stageNumber: 3,
    title: 'Contract & Statements',
    description: 'This will allow Casual & Fair Work Statement, Bank Account and Next of Kin to be edited, and Stage 3 will need to be resubmitted.',
    reopenOptions: [
      {
        id: 'reopen_tfn_declaration',
        label: 'Reopen TFN Declaration step as well',
        type: 'checkbox',
      },
      {
        id: 'reopen_superannuation',
        label: 'Reopen Superannuation step as well',
        type: 'checkbox',
      },
      {
        id: 'reopen_contract',
        label: 'Reopen Contract step as well',
        type: 'checkbox',
      },
    ],
    notificationOption: {
      id: 'notify_employee',
      label: 'Notify and request employee to edit themselves and resubmit',
      type: 'checkbox',
    },
  },
};

export const MAX_STAGES = 3;
